/* eslint-disable no-unused-vars */
export const urls = {
    postLeadDownloadRequest: '/api/re-projects/v1/real-estate/business/leads/download/initiate',
    getLeadPreparationStatus: '/api/re-projects/v1/real-estate/business/leads/download/status'
};

export const REQUEST_STATUS = {
    COMPLETED: 'completed',
    FAILED: 'error',
    INPROCESS: 'progress',
    QUEUED: 'queued',
    WARNING: 'warning'
};

export const initialState = {
    prepationQueue: [],
    failedQueue: [],
    displayList: [],
    requestInfo: {},
    adRequestMapping: {},
    showRequestExistModal: false,
    showRequestExistInfo: {},
    isFetching: {}
};

const updateLeadPreparationStatus = (state, response) => {
    const requestStatusObj = response.data.data;
    const currTime = (new Date()).getTime();
    const queueStatus = {
        prepationQueue: [],
        failedQueue: [...state.failedQueue],
        requestInfo: {
            ...state.requestInfo
        }
    };

    state.prepationQueue.forEach(requestId => {
        let requestStatusInfo = requestStatusObj.status[requestId];
        const expiryTime = state.requestInfo[requestId].expiryTime;

        if (!(requestStatusInfo && requestStatusInfo.status)) {
            requestStatusInfo = {
                status: REQUEST_STATUS.INPROCESS,
                message: ''
            };
        }

        // handling timeout
        if (currTime > expiryTime && ([REQUEST_STATUS.QUEUED, REQUEST_STATUS.INPROCESS].indexOf(requestStatusInfo.status) !== -1)) {
            requestStatusInfo.status = REQUEST_STATUS.FAILED;
            requestStatusInfo.message = '';
            requestStatusInfo.errorMsgId = 'requestTimeoutText';
        }

        switch (requestStatusInfo.status) {
            case REQUEST_STATUS.COMPLETED:
                queueStatus.requestInfo[requestId].status = requestStatusInfo.status;
                queueStatus.requestInfo[requestId].message = requestStatusInfo.message;
                queueStatus.requestInfo[requestId].downloadLink = requestStatusInfo.downloadLink;
                break;
            case REQUEST_STATUS.QUEUED:
            case REQUEST_STATUS.INPROCESS:
                queueStatus.prepationQueue.push(requestId);
                queueStatus.requestInfo[requestId].status = requestStatusInfo.status;
                queueStatus.requestInfo[requestId].message = requestStatusInfo.message;
                break;
            case REQUEST_STATUS.FAILED:
                queueStatus.failedQueue.push(requestId);
                queueStatus.requestInfo[requestId].status = requestStatusInfo.status;
                queueStatus.requestInfo[requestId].message = requestStatusInfo.message;
                queueStatus.requestInfo[requestId].errorMsgId = requestStatusInfo.errorMsgId;
                break;
            case REQUEST_STATUS.WARNING:
                queueStatus.requestInfo[requestId].status = requestStatusInfo.status;
                queueStatus.requestInfo[requestId].message = requestStatusInfo.message;
                break;
            default:
                queueStatus.failedQueue.push(requestId);
                queueStatus.requestInfo[requestId].status = REQUEST_STATUS.FAILED;
                queueStatus.requestInfo[requestId].message = '';
                queueStatus.requestInfo[requestId].errorMsgId = 'defaultFailedText';
        }
    });

    queueStatus.failedQueue = queueStatus.failedQueue.filter((item, pos) => queueStatus.failedQueue.indexOf(item) == pos);

    return queueStatus;
};

const getStateFilteredArray = (state, arr, filterCb) => {
    return state[arr].filter(filterCb);
};

const leadDownloads = (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_LEAD_DOWNLOAD_REQUEST': {
            const { [action.data.id]: removedIsFetching, ...newIsFetching } = state.isFetching;

            return {
                ...state,
                displayList: [action.data.requestId].concat(state.displayList),
                prepationQueue: state.prepationQueue.concat([action.data.requestId]),
                requestInfo: {
                    ...state.requestInfo,
                    [action.data.requestId]: { ...action.data }
                },
                adRequestMapping: {
                    ...state.adRequestMapping,
                    [action.data.id]: action.data.requestId
                },
                isFetching: { ...newIsFetching }
            };
        }
        case 'ERROR_LEAD_DOWNLOAD_REQUEST': {
            const { [action.data.id]: removedIsFetching, ...newIsFetching } = state.isFetching;

            return {
                ...state,
                displayList: [action.data.requestId].concat(state.displayList),
                failedQueue: state.failedQueue.concat([action.data.requestId]),
                requestInfo: {
                    ...state.requestInfo,
                    [action.data.requestId]: { ...action.data }
                },
                isFetching: { ...newIsFetching }
            };
        }
        case 'RECEIVE_LEAD_PREPARATION_REQUEST': {
            const newQueueState = updateLeadPreparationStatus(state, action.data);

            return {
                ...state,
                ...newQueueState
            };
        }
        case 'ERROR_LEAD_PREPARATION_REQUEST': {
            return {
                ...state
            };
        }
        case 'TOGGLE_REQUEST_EXIST_MODAL': {
            const { [action.data.showRequestExistInfo.id]: removedIsFetching, ...newIsFetching } = state.isFetching;

            return {
                ...state,
                showRequestExistModal: action.data.showRequestExistModal,
                showRequestExistInfo: action.data.showRequestExistInfo,
                isFetching: { ...newIsFetching }
            };
        }
        case 'HARD_REMOVE_FAILED_LEAD_DOWNLOAD_REQUEST': {
            const { [action.data.adId]: removedAdRequestMapping, ...newAdRequestMapping } = state.adRequestMapping;
            const { [action.data.requestId]: removedRequestInfo, ...newRequestInfo } = state.requestInfo;

            return {
                ...state,
                failedQueue: getStateFilteredArray(state, 'failedQueue', requestId => requestId !== action.data.requestId),
                displayList: getStateFilteredArray(state, 'displayList', requestId => requestId !== action.data.requestId),
                adRequestMapping: {
                    ...newAdRequestMapping
                },
                requestInfo: {
                    ...newRequestInfo
                }
            };
        }
        case 'SOFT_REMOVE_FAILED_LEAD_DOWNLOAD_REQUEST': {
            const { [action.data.adId]: removedAdRequestMapping, ...newAdRequestMapping } = state.adRequestMapping;

            return {
                ...state,
                failedQueue: getStateFilteredArray(state, 'failedQueue', requestId => requestId !== action.data.requestId)
            };
        }
        case 'REQUEST_LEAD_DOWNLOAD': {
            return {
                ...state,
                isFetching: {
                    ...state.isFetching,
                    [action.data]: true
                }
            };
        }
        default:
            return state;
    }
};

export default leadDownloads;
